module.exports = __webpack_public_path__ + "img/ht.a0b173a.svg";